import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useAuth } from '../../../context/auth-context';
import { toast } from 'react-toastify';
import axios from 'axios';
import { rootUrl } from '../../../helpers';

const AddBillModal = ({ data, onSubmit, type }) => {
    const auth = useAuth();
    const [lastType, setLastType] = useState(null);
    const [projects, setProjects] = useState([]);
    const [entry, setEntry] = useState({
        uniId: null,
        project: null,
        amount: '',
        desc: '',
    });
    const [entriesList, setEntriesList] = useState([]);

    const initialFormData = {
        customer: null,
        sof: null,
        colce: null,
        bank: null,
        invoice: null,
        entries: [],
    };

    const [formData, setFormData] = useState(initialFormData);

    // Fetch projects when budget changes
    useEffect(() => {
        if (entry.uniId) {
            const fetchProjects = async () => {
                try {
                    const response = await axios.get(rootUrl(`/getProj/${entry.uniId.value}`));
                    setProjects(response.data.data || []);
                } catch (error) {
                    console.error('Error fetching projects:', error);
                }
            };
            fetchProjects();
        } else {
            setProjects([]);
        }
    }, [entry.uniId, auth.token]);

    const handleEntryChange = (field, value) => {
        setEntry((prev) => ({ ...prev, [field]: value }));
    };

    const handleAddToList = () => {
        if (entry.uniId && entry.amount && entry.desc) {
            setEntriesList((prev) => [...prev, entry]);
            setEntry({ uniId: null, project: null, amount: '', desc: '' });
        } else {
            toast.info('Please fill all fields before adding to the list.');
        }
    };

    const handleFormSubmit = async () => {
        setIsSubmitDisabled(true)
        if (type === 2) {
            formData['lastType'] = lastType;
        }
        const payload = { ...formData, entries: entriesList };
        await onSubmit(payload);
    };

    const typeOptions = [
        { value: "1", label: "Payment" },
        { value: "2", label: "Invoice" },
    ];

    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

    useEffect(() => {
        setIsSubmitDisabled(
            !formData.customer ||
            !formData.sof ||
            !formData.colce ||
            !formData.bank ||
            entriesList.length === 0)
    },[formData, entriesList])
  

    return (
        <div className="p-6 bg-gray-50 rounded-lg shadow-lg">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {/* Static Fields */}
                <div>
                    <h3 className="text-lg font-semibold mb-4">Form Data</h3>
                    <Select
                        options={data.budget.map((option) => ({
                            value: option.id,
                            label: `${option.coa} - ${data.coa?.find(
                                (a) => a.account === option.coa
                            )?.name}`,
                        }))}
                        placeholder="Select budget item"
                        onChange={(selected) => handleEntryChange('uniId', selected)}
                        value={entry.uniId}
                        className="mb-4"
                    />
                    <Select
                        options={projects.map((project) => ({
                            value: project.id,
                            label: project.name,
                        }))}
                        placeholder="Select Project"
                        onChange={(selected) => handleEntryChange('project', selected)}
                        value={entry.project}
                        isDisabled={!entry.uniId}
                        className="mb-4"
                    />
                    <input
                        type="text"
                        placeholder="Enter Amount"
                        className="border rounded p-2 w-full mb-4"
                        value={entry.amount}
                        onChange={(e) => handleEntryChange('amount', e.target.value)}
                    />
                    <textarea
                        placeholder="Enter Description"
                        className="border rounded p-2 w-full mb-4"
                        rows={3}
                        value={entry.desc}
                        onChange={(e) => handleEntryChange('desc', e.target.value)}
                    />
                    <button
                        className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded w-full"
                        onClick={handleAddToList}
                    >
                        Add to List
                    </button>
                </div>

                {/* Additional Fields */}
                <div>
                    <h3 className="text-lg font-semibold mb-4">Additional Information</h3>
                    <Select
                        options={
                            type === 2
                                ? data.suppliers.map((option) => ({
                                      value: option.id,
                                      label: `${option.name}`,
                                  }))
                                : data.customer.map((option) => ({
                                      value: option.id,
                                      label: `${option.firstname} ${option.lastname}`,
                                  }))
                        }
                        placeholder={type === 2 ? "Select Supplier" : "Select Customer"}
                        onChange={(selected) =>
                            setFormData({ ...formData, customer: selected })
                        }
                        value={formData.customer}
                        className="mb-4"
                    />
                    <Select
                        options={data.sof.map((option) => ({
                            value: option.id,
                            label: `${option.name}`,
                        }))}
                        placeholder="Source of Funds"
                        onChange={(selected) =>
                            setFormData({ ...formData, sof: selected })
                        }
                        value={formData.sof}
                        className="mb-4"
                    />
                    <Select
                        options={data.cc.map((option) => ({
                            value: option.id,
                            label: `${option.collection_name}`,
                        }))}
                        placeholder="Select Collection Center"
                        onChange={(selected) =>
                            setFormData({ ...formData, colce: selected })
                        }
                        value={formData.colce}
                        className="mb-4"
                    />
                    <Select
                        options={data.bank.map((option) => ({
                            value: option.id,
                            label: `${option.name}`,
                        }))}
                        placeholder="Select Bank"
                        onChange={(selected) =>
                            setFormData({ ...formData, bank: selected })
                        }
                        value={formData.bank}
                        className="mb-4"
                    />
                    <input
                        type="text"
                        placeholder="Invoice"
                        className="border rounded p-2 w-full mb-4"
                        value={formData.invoice}
                        onChange={(e) =>
                            setFormData({ ...formData, invoice: e.target.value })
                        }
                    />
                    {type === 2 ? (
                        <Select
                            options={typeOptions}
                            placeholder="Select type"
                            onChange={(selected) => setLastType(selected)}
                            value={
                                typeOptions.find((option) => option.value === lastType?.value) ||
                                null
                            }
                            className="mb-4"
                        />
                    ) : null}
                    <button
                        className={`py-2 px-4 rounded w-full font-bold ${
                            isSubmitDisabled
                                ? 'bg-gray-400 text-gray-700 cursor-not-allowed'
                                : 'bg-green-500 hover:bg-green-600 text-white'
                        }`}
                        onClick={handleFormSubmit}
                        disabled={isSubmitDisabled}
                    >
                        Submit
                    </button>
                </div>
            </div>

            {/* Dynamic List */}
            <div className="mt-6">
                <h3 className="text-lg font-semibold mb-4">Entries List</h3>
                {entriesList.length > 0 ? (
                    <div className="overflow-x-auto">
                        <table className="min-w-full border-collapse border border-gray-200">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="px-4 py-2 border border-gray-200 text-left text-sm font-medium text-gray-700">
                                        Chart of Account
                                    </th>
                                    <th className="px-4 py-2 border border-gray-200 text-left text-sm font-medium text-gray-700">
                                        Project
                                    </th>
                                    <th className="px-4 py-2 border border-gray-200 text-left text-sm font-medium text-gray-700">
                                        Amount
                                    </th>
                                    <th className="px-4 py-2 border border-gray-200 text-left text-sm font-medium text-gray-700">
                                        Description
                                    </th>
                                    <th className="px-4 py-2 border border-gray-200 text-center text-sm font-medium text-gray-700">
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {entriesList.map((item, index) => (
                                    <tr key={index} className="bg-white hover:bg-gray-50">
                                        <td className="px-4 py-2 border border-gray-200 text-sm text-gray-700">
                                            {item.uniId.label}
                                        </td>
                                        <td className="px-4 py-2 border border-gray-200 text-sm text-gray-700">
                                            {item.project?.label || 'N/A'}
                                        </td>
                                        <td className="px-4 py-2 border border-gray-200 text-sm text-gray-700">
                                            {item.amount}
                                        </td>
                                        <td className="px-4 py-2 border border-gray-200 text-sm text-gray-700">
                                            {item.desc}
                                        </td>
                                        <td className="px-4 py-2 border border-gray-200 text-center">
                                            <button
                                                className="bg-red-500 text-white py-1 px-3 rounded hover:bg-red-600 text-sm"
                                                onClick={() =>
                                                    setEntriesList((prev) =>
                                                        prev.filter((_, i) => i !== index)
                                                    )
                                                }
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p className="text-sm text-gray-500">No entries added yet.</p>
                )}
            </div>
        </div>
    );
};

export default AddBillModal;
